import React from 'react';
import ProductPrice from '@repo/ui/src/components/Product/Price';
import { useProductContext } from '@context/ProductProvider';
import { classNames } from '@repo/ui/src/utils/classNames';
import { useVipAccess } from '@hooks/customer';

interface PromotionsProps {
  dark?: boolean;
  className?: string;
}

const PromotionsAndPricing = ({ dark = false, className }: PromotionsProps) => {
  const { mainProduct: product } = useProductContext();
  const { vip } = useVipAccess();

  if (!product) {
    return null;
  }

  return (
    <div className={classNames('flex-row text-center gap-6', className)}>
      <ProductPrice
        product={product}
        component="h5"
        variant="h5"
        className="tra-text-web-heading-5 items-center w-auto [&_del]:text-neutral-400 [&_del]:justify-self-center"
        color={dark ? 'white' : undefined}
        vip={vip}
      />
    </div>
  );
};

export default PromotionsAndPricing;
